import { useQuery } from '@apollo/client';
import useBusinessConfiguration from '../../../../../../hooks/useBusinessConfiguration';
import { NBUserLifeCycleStatus } from '../../../../../../types/enums';
import { hasTentativeThisMonth, hasUserSubscribedThisMonth, } from '../../../../../../utils/dates';
import { getShipmentSummaryItems, getStarterKitShipmentSummaryItem, } from '../../../../../../utils/nextShipment';
import GET_DETAILED_NEXT_SHIPMENT_SUMMARY from './GET_DETAILED_NEXT_SHIPMENT_SUMMARY';
var useDetailedNextShipmentSummary = function () {
    var _a;
    var program = useBusinessConfiguration().program;
    var _b = useQuery(GET_DETAILED_NEXT_SHIPMENT_SUMMARY, {
        variables: { program: program },
        errorPolicy: 'ignore',
    }), data = _b.data, loading = _b.loading, error = _b.error;
    var layout = data === null || data === void 0 ? void 0 : data.me.layout;
    var subscription = data === null || data === void 0 ? void 0 : data.me.subscription;
    var currentCycle = subscription === null || subscription === void 0 ? void 0 : subscription.currentCycle;
    var items = (_a = subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionItems) !== null && _a !== void 0 ? _a : [];
    var shipmentItems = getShipmentSummaryItems(items);
    var starterKitItem = getStarterKitShipmentSummaryItem(items);
    var tentativeIsThisMonth = hasTentativeThisMonth(starterKitItem);
    var isAcquisitionMonth = hasUserSubscribedThisMonth(subscription === null || subscription === void 0 ? void 0 : subscription.dateCreated);
    var isFulfilledShipment = [
        NBUserLifeCycleStatus.FULFILLED,
        NBUserLifeCycleStatus.SHIPPED,
    ].includes(currentCycle === null || currentCycle === void 0 ? void 0 : currentCycle.status);
    var rollingAdjustmentsFlag = data === null || data === void 0 ? void 0 : data.me.layout.rollingAdjustmentsFlag;
    var isSubCreatedCurrentMonth = isAcquisitionMonth && starterKitItem;
    var isSKDeliveryPending = tentativeIsThisMonth || (currentCycle && !isFulfilledShipment);
    var shouldShowStarterKitShipmentSummary = rollingAdjustmentsFlag
        ? !!(isSubCreatedCurrentMonth && isSKDeliveryPending)
        : !!(isAcquisitionMonth && currentCycle && !isFulfilledShipment);
    var shouldShowShipmentSummary = !shouldShowStarterKitShipmentSummary;
    var shouldShowEmptyShipmentSummary = (shouldShowStarterKitShipmentSummary && !starterKitItem) ||
        (shouldShowShipmentSummary && !shipmentItems.length);
    return {
        loading: loading,
        error: error,
        subscription: subscription,
        shipmentItems: shipmentItems,
        starterKitItem: starterKitItem,
        shouldShowStarterKitShipmentSummary: shouldShowStarterKitShipmentSummary,
        shouldShowShipmentSummary: shouldShowShipmentSummary,
        shouldShowEmptyShipmentSummary: shouldShowEmptyShipmentSummary,
        content: {
            starterKitShipmentSummaryContent: layout === null || layout === void 0 ? void 0 : layout.starterKitShipmentSummaryContent,
            shipmentSummaryContent: layout === null || layout === void 0 ? void 0 : layout.shipmentSummaryContent,
            emptyShipmentSummaryContent: layout === null || layout === void 0 ? void 0 : layout.emptyShipmentSummaryContent,
        },
    };
};
export default useDetailedNextShipmentSummary;
